import { type ReactElement, Suspense } from "react";
import { useTranslation } from "react-i18next";
import SwitchPeriodSummaryMode from "@/pages/human-resources/time-management/schedules/site-schedule/analysis/period-summary/SwitchPeriodSummaryMode.tsx";
import { usePeriodSummaryCardController } from "@/pages/human-resources/time-management/schedules/site-schedule/analysis/period-summary/usePeriodSummaryCardController.ts";
import useScheduleReferenceData from "@/pages/human-resources/time-management/schedules/reference-provider/useScheduleReferenceData.ts";
import PeriodEventsDropdown from "@/pages/human-resources/time-management/schedules/site-schedule/analysis/period-summary/PeriodEventsDropdown.tsx";
import "./PeriodSummaryCard.scss";
import PeriodSummaryCardBody from "@/pages/human-resources/time-management/schedules/site-schedule/analysis/period-summary/PeriodSummaryCardBody.tsx";

export default function PeriodSummaryCard(): ReactElement {
  const { t } = useTranslation("humanResources");
  const {
    siteData: { siteId },
  } = useScheduleReferenceData();
  const controller = usePeriodSummaryCardController("FORECAST");
  const emptyLine = <div className="empty-line" />;

  const title =
    controller.range === "DAY" ?
      t("timeManagement.analysis.daySummary")
    : t("timeManagement.analysis.monthSummary");

  return (
    <div className="day-summary-card">
      <div className="card-header">
        <div className="card-title">{title}</div>
        <div className="card-toolbar">
          <SwitchPeriodSummaryMode
            mode={controller.mode}
            date={controller.date}
            onChange={controller.setMode}
            range={controller.range}
          />
          <Suspense fallback={emptyLine}>
            {controller.mode !== "TREND" ?
              <PeriodEventsDropdown
                mode={controller.mode}
                siteId={siteId}
                date={controller.date}
                range={controller.range}
              />
            : emptyLine}
          </Suspense>
        </div>
      </div>
      <PeriodSummaryCardBody
        domainId={controller.domainId}
        siteId={controller.siteId}
        date={controller.date}
        range={controller.range}
        mode={controller.mode}
      />
    </div>
  );
}
